import React, { PureComponent } from 'react';
import { Card, CardBody, Col, ButtonToolbar } from 'reactstrap';
import { withRouter } from 'react-router-dom';
// import cart_list from './cart_list';
import Table from '../../../../components/table/Table';
import DeleteForeverIcon from 'mdi-react/DeleteForeverIcon';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { purchaseProducts } from '../../../../redux/actions/stripeActions'
import renderSelectField from '../../../../components/Select';
import Modal from '../../../../components/Modal';
import PurchaseModal from '../../../../components/PurchaseModal';
import { removeItem, updateItem } from '../../../../redux/actions/cartActions';
import { loadProducts } from '../../../../redux/actions/productActions'
import { GetProducts } from '../../../../queries/products'
import { withApollo, Mutation } from 'react-apollo';
import { EditProductQuantity, requestPurchase } from '../../../../queries/cart'; //
import { loader as Loader } from '../../../Loader';
import Notification from '../../../../components/Notification'

class CartCard extends PureComponent {
  state = {
    total: 0,
    deleteItemModalOpen: false,
    purchaseModalOpen: false,
    currentProd: null,
    productDetails: [],
    tempquantity: 0,
    requesting: false,
    loadingCart: true,
    requestSuccess: false,
    requestFailure: false
  }

  getTotalPrice() {
    let total = 0;
    this.props.cartItems.map(item => {
      return total += (item.price * item.quantity)
    })
    this.setState({ total })
  }

  /**
   * We need to map our cart items to our products 
   * to display certain details.
   */
  async mapProducts() {
    let mappedProducts = [];
    try {
      //if we already have products in our redux state we can use this data
      if (this.props.products && this.props.cartItems) {
        mappedProducts = this.props.cartItems.map(reduxCartItem => {
          return this.props.products.find(product => {
            return reduxCartItem.productID === product.productName
          })
        })
      } else if (this.props.cartItems) {
        //get products from query
        const { data: productData } = await this.props.client.query({
          query: GetProducts(),
          fetchPolicy: 'network-only'
        })
        this.props.loadProducts(productData.listProducts.items)
        mappedProducts = productData.listProducts.items.map(reduxCartItem => {
          return this.props.products.find(product => {
            return reduxCartItem.productID === product.productName
          })
        })
      }
      this.setState({ productDetails: mappedProducts })


    } catch (err) {
      console.log(err.message)
    }
  }

  async handlePurchase(e) {
    e.preventDefault();

    this.togglePurchaseModal();
  }

  async makePurchase() {

  }

  async handlePurchaseRequest(e) {
    e.preventDefault();
    this.setState({ requesting: true })

    try {
      let products = this.props.cartItems.map(i => {
        return {
          productName: i.productName,
          productShortDescription: i.productShortDescription,
          productPrice: parseFloat(i.price).toFixed(2) / 100,
          quantity: i.quantity
        }
      })

      let purchaseRequest = {
        requesterName: this.props.user.given_name,
        productData: products
      }
      await this.props.client.query({
        query: requestPurchase(purchaseRequest),
        fetchPolicy: 'network-only',
        variables: { requestData: purchaseRequest }
      })

      this.setState({ requesting: false, requestSuccess: true })
    } catch (e) {
      console.log(e)
      this.setState({ requesting: false, requestFailure: true })
    }

  }

  componentDidUpdate(prevProps, prevState) {
    return prevProps.cartItems !== this.props.cartItems ?
      this.getTotalPrice() : null;
  }

  componentDidMount() {
    // this.mapProducts().then(e => {
    //   console.log('Done')
    //   console.log(this.state.productDetails)
    // });
    this.getTotalPrice();
    if (this.props.cartItems && Array.isArray(this.props.cartItems)) {
      this.setState({ loadingCart: false })
    }
  }

  toggleModal() {
    return this.setState({ deleteItemModalOpen: !this.state.deleteItemModalOpen });
  }

  togglePurchaseModal() {
    return this.setState({ purchaseModalOpen: !this.state.purchaseModalOpen });
  }

  confirmDelete(id, price, quantity) {
    this.props.removeItem(id);
    this.setState({ total: this.state.total - (parseFloat(price).toFixed(2) * quantity) })
  }

  render() {
    return (
      this.state.loadingCart ? <Loader /> :
        <React.Fragment>
          <Col md={12} lg={12}>
            <React.Fragment>
              <button className='btn btn-secondary'
                onClick={() => {
                  this.props.history.push('/app/marketplace');
                }}
                style={{
                  float: 'left'
                }}> {'<< Back To Marketplace'}</button>
              <Card className='cart'>
                {this.state.requestSuccess &&
                  <Notification
                    position='tr'
                    title='Success'
                    message='Success! Your purchase request has been sent!'
                    className='success' />
                }
                {this.state.requestFailure &&
                   <Notification
                   position='tr'
                   title='Uh-Oh'
                   message='Looks like something went wrong'
                   className='error' />
                }
                <CardBody>
                  <div className='card__title'>
                    <h5 className='bold-text'>Cart</h5>
                  </div>
                  <Table className='table--bordered cart__table' responsive>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Quantity</th>
                        <th>Unit Price</th>
                        <th>Total</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.cartItems.map((cartItem, i) => {
                        return <tr key={i}>
                          <td>{i + 1}</td>
                          <td>
                            <span className='cart__preview-img'>
                              {cartItem.images && cartItem.images.length > 0 ?
                                <img src={cartItem.images[0]} alt='product_preview' /> :
                                <span className='lnr lnr-license' />}
                            </span>
                            <span>{cartItem.productName}</span>
                          </td>
                          <td>
                            <span>{cartItem.productShortDescription}</span>
                          </td>
                          <td>
                            <Mutation mutation={EditProductQuantity}
                              onCompleted={(data) => {
                                this.props.updateItem(cartItem.productID ? cartItem.productID
                                  : cartItem.productName, this.state.tempquantity, this.props.cartItems)

                                this.setState({ tempquantity: 0 })
                              }}
                              onError={() => {
                                this.setState({ tempquantity: 0 })
                              }}>
                              {(editProductQuantity) => {
                                return <Field
                                  name='select'
                                  component={renderSelectField}
                                  clearable={false}
                                  defaultValue={cartItem.quantity}
                                  options={[...Array(10)].map((_, i) => {
                                    return { value: i + 1, label: i + 1 }
                                  })}
                                  onChange={(newquantity) => {

                                    this.setState({ tempquantity: newquantity.value })
                                    editProductQuantity({
                                      variables: {
                                        productId: cartItem.productID ? cartItem.productID : cartItem.productName,
                                        quantity: parseFloat(newquantity.value)
                                      }
                                    })
                                  }}
                                />
                              }}
                            </Mutation>

                          </td>
                          <td>${parseFloat(cartItem.price).toFixed(2) / 100}</td>
                          <td>${parseFloat(cartItem.price).toFixed(2) / 100 * cartItem.quantity}</td>
                          <td>
                            <button className='cart__table-btn' onClick={() => {

                              this.setState({ currentProd: cartItem }, () => {
                                this.toggleModal();
                              })
                            }}>
                              <DeleteForeverIcon /> Remove
                    </button>
                          </td>
                        </tr>
                      }
                      )}
                    </tbody>
                  </Table>
                  <h4 className='cart__sub-total'>Total: ${this.state.total.toFixed(2) / 100}</h4>
                  <ButtonToolbar
                    className={`form__button-toolbar ${this.props.cartItems.length || this.state.requesting ?
                      '' : 'isDisabled'}`} >
                    {
                      (this.props.user &&
                        this.props.user['cognito:groups'] &&
                        this.props.user['cognito:groups'].find(e => {
                          return e.includes('Admin') ||
                            e.includes('Manager')
                        })) ?
                        <Link
                          id='purchase'
                          className={`btn btn-primary ${this.props.cartItems.length ? '' :
                            'isDisabled'}`}
                          to='#'
                          onClick={e => this.props.cartItems.length > 0 ?
                            this.handlePurchase(e) :
                            e.preventDefault()}
                        >Purchase</Link>
                        :
                        this.state.requesting || !this.props.cartItems.length ?
                          <Link id='req-purchase'
                            className={`btn btn-info isDisabled`}
                            to='#'
                          >Request Purchase</Link>
                          :
                          <Link id='req-purchase'
                            className={`btn btn-info`}
                            to='#' onClick={this.handlePurchaseRequest.bind(this)}
                          >Request Purchase</Link>
                    }

                    <br />

                  </ButtonToolbar>
                </CardBody>
              </Card>
              <Modal
                ct={this.state.currentProd}
                Msg="Are you sure you want to remove this item?"
                modal={this.state.deleteItemModalOpen}
                toggle={this.toggleModal.bind(this)}
                color="danger"
                showButtonBar={true}
                confirmDelete={this.confirmDelete.bind(this)}
                className="cart__modal"
              />

              <PurchaseModal
                ct={this.state.currentProd}
                Msg="Fill in your card details"
                modal={this.state.purchaseModalOpen}
                toggle={this.togglePurchaseModal.bind(this)}
                color="success"
                showButtonBar={true}
                price={this.state.total.toFixed(2) / 100}
                className="cart__modal"
              />
            </React.Fragment>

          </Col>
        </React.Fragment>
    )
  }
}
function mapStateToProps(state) {
  return {
    cartItems: state.cartData.items,
    purchaseResponse: state.stripeData.purchaseResponse,
    products: state.productsData ? state.productsData.products : null,
    user: state.auth.user
  }
}

export default withRouter(withApollo(connect(mapStateToProps, {
  removeItem,
  updateItem,
  purchaseProducts,
  loadProducts
})(reduxForm({ form: "cart-form" })(CartCard))))


// WEBPACK FOOTER //
// ./src/components/e-commerce/cart/components/CartCard.js